module.exports = __webpack_public_path__ + "assets/img/returnBtn-f2bb4fd8.png";